export type PaginationParams = {
    page?: number;
    size?: number;
    search?: string;
};

export type PaginatedResponse<T> = {
    content: T[];
    totalCount: number;
    page: number;
    size: number;
};

export function getPaginatedContent<T>(data: T[] | PaginatedResponse<T>): T[] {
    if (Array.isArray(data)) {
        return data;
    }
    return data.content ?? [];
}